import { useMemo } from 'react';
import {
  IS_TIER1_PAGE,
  IS_VLP_PAGE,
  IS_VDP_PAGE,
  IS_OFFERS_PAGE,
  IS_BUILD_PAGE,
  IS_MODELS_PAGE,
  IS_FYM_PAGE,
} from '../constants/environment';

const useSourceOfLead = (isUSMarket?: boolean, isAfterSales?: boolean) => {
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const generalSource = useMemo(() => {
    if (IS_TIER1_PAGE) return 'tier_1';
    return 'tier_3';
  }, []);

  const specificSource = useMemo(() => {
    if (IS_VLP_PAGE) return 'vlp';
    if (IS_VDP_PAGE) return 'vdp';
    if (IS_OFFERS_PAGE && !IS_TIER1_PAGE) return 'specials';
    if (IS_OFFERS_PAGE) return 'offers';
    if (IS_BUILD_PAGE) return 'config';
    if (IS_MODELS_PAGE) return 'mlp';
    // Temp solution
    // if (IS_FYM_PAGE) return 'fym';
    if (IS_FYM_PAGE) return 'vlp';
    return IS_TIER1_PAGE ? 'generic' : 'general';
  }, []);

  const requestSource = useMemo(() => {
    if (IS_TIER1_PAGE && !isUSMarket) return 'AudiCA';
    if (isAfterSales || (!IS_TIER1_PAGE && !isUSMarket)) return 'oADD';
    return generalSource;
  }, [generalSource, isAfterSales, isUSMarket]);

  return { url, generalSource, specificSource, requestSource };
};

export default useSourceOfLead;
